'use strict'

import { Budoux } from './lib/Budoux'
import { Smooth } from './lib/Smooth'
import { TelGrant } from './lib/TelGrant'
import { EqualHeight } from './lib/EqualHeight'
import { Drawer } from './lib/Drawer'
import { Svg } from './lib/Svg'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { WindowStatus } from './lib/WindowStatus'
import { ViewportHeight } from './lib/ViewportHeight'
import { Zipcode } from './lib/Zipcode'
import { reasonGallery } from './lib/reasonGallery'
import { worksSlider } from './lib/worksSlider'
import { MegaMenu } from './lib/MegaMenu'
import { Accordion } from './lib/Accordion'
import { DownloadSlider } from './lib/DownloadSlider'
import { KvSize } from './lib/KvSize'
import { CtaRandom } from './lib/CtaRandom'
import { TextSplit } from './lib/TextSplit'
import { Opening } from './lib/Opening'
import { StickyFunc } from './lib/StickyFunc'
import { ScrollAnchor } from './lib/ScrollAnchor'
import { RelatedSlider } from './lib/RelatedSlider'
import { specSlider } from './lib/specSlider'
import { RobotComp } from './lib/RobotComp'
import { DownloadForm } from './lib/DownloadForm'
import { SearchColumn } from './lib/SearchColumn'
import { SearchCase } from './lib/SearchCase'
import { SearchSubsidy } from './lib/SearchSubsidy'
import { OrderSubsidy } from './lib/OrderSubsidy'
import { DownloadThumbSlider } from './lib/DownloadThumbSlider'
import { FormOther } from './lib/FormOther'
import { DownloadCustom } from './lib/DownloadCustom'

new Budoux()
new WindowStatus()
new ViewportHeight()
new Svg()
new ScrollAnimation()
new Drawer()
new Smooth()
new EqualHeight('.js-max_height', '3')
new TelGrant()
new Zipcode()
new reasonGallery()
new worksSlider()
new MegaMenu()
new Accordion()
new DownloadSlider()
new KvSize()
new CtaRandom()
new TextSplit()
new Opening()
new StickyFunc()
new ScrollAnchor()
new RelatedSlider()
new specSlider()
new RobotComp()
new DownloadForm()
new SearchColumn()
new SearchCase()
new SearchSubsidy()
new OrderSubsidy()
new DownloadThumbSlider()
new FormOther()
new DownloadCustom()
